import React from 'react';

import fetch from '../fetch';


import utils from './../../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    data: [],
    refresh: function() {

    }
}

const headers = utils.columns([
    {type: 'selection'},
    {
        key:'$index', 
        label: '序号'
    },
    {
        key:'subName', 
        width: 200, 
        label: '观察要素',
        render: (data, columns) => {
            return (
                <div style={{whiteSpace: 'pre-line', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: `${columns.evaluationDetailList.length}`, WebkitBoxOrient: 'vertical'}}>
                    {data}
                </div>
            )
        }
    },
    {
        key:'subDetailList', 
        label: '实际情况', 
        width: 200,
        height: 100,
        render: (data) => {
            if(data && data.length > 0) {
                return data.map((d, index) => (
                    <div style={{height: 30}}>
                        {`${index + 1}、${d.name}`}
                    </div>
                ))
            }
            return "";
        }
    },
    {
        key:'evaluationDetailList', 
        label: '审核标准',
        render: (data, columns) => {
            if(data && data.length > 0) {
                if(columns.isEvaluation) {
                    return (
                        <ol className="upper-alpha">
                            {
                                data.map(d => (
                                <li>{d.min} ~ {d.max}</li>
                                ))
                            }
                        </ol>
                    )
                } else {
                    // return data.map(d => (
                    //     <div>{d.label}</div>
                    // ))
                    return (
                        <ol className="upper-alpha">
                            {
                                data.map(d => (
                                <li>{d.label}</li>
                                ))
                            }
                        </ol>
                    )
                }
            }
            return "";
        }
    },
    {
        key: 'approvalOrgNameList',
        label: '审核部门', 
        render: (data) => {
            if(data && data.length > 0) {
                return <span> {data.join('、')}</span>
            }
            return "";
        }
    },
    // {
    //     key: 'isUploadAttachment',
    //     label: '是否可上传附件',
    //     width: 140,
    //     render: (data) => {
    //         if(data) {
    //             return '是';
    //         }
    //         return '否';
    //     } 
    // },
    {
        key: 'isEvaluation',
        label: '是否可计算分数',
        width: 140,
        render: (data) => {
            if(data) {
                return '是';
            }
            return '否';
        } 
    },
    {
        key: 'isNeedSub',
        label: '是否是必选项',
        width: 140,
        render: (data) => {
            if(data) {
                return '是';
            }
            return '否';
        } 
    },
    {
        key: 'subDesc',
        label: '备注',
        width: 250,
        render: (data, columns) => {
            return (
                <div style={{whiteSpace: 'pre-line', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: `${columns.evaluationDetailList.length}`, WebkitBoxOrient: 'vertical'}}>
                    {data}
                </div>
            )
        }
    },
]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords) => {
    const id = keywords.targetId
    if(!id) {
        return new Promise(() => {
            const list = (Object.assign({
                result: [].map(item => {
                    return Object.assign({}, item, {
                        height: (item.choices || []).length * 30
                    })
                }),
                selects: [].map(d => ({
                    value: d.id,
                    checked: false,
                    height: (d.choices || []).length * 30
                })),
                checked: false,
                total: data.total,
                pageIndex: data.pageNum,
                pageSize: data.pageSize,
                notify: [].length ? '' : '暂无数据...'
            }));
            return list; 
        })
    }
    return fetch.get(`zyzgsubitem/get/${id}`)
    .then(response => {
        return response.payload.data;
    })
    .then(data => {
        const list = (Object.assign({
            result: (data || []).map(item => {
                return Object.assign({}, item, {
                    height: (item.evaluationDetailList || []).length * 30
                })
            }),
            selects: (data || []).map(d => ({
                value: d.subId,
                checked: false,
                height: (d.evaluationDetailList || []).length * 30
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data || []).length ? '' : '暂无数据...'
        }));
        DataGrid.data = list.result;
        return list;
    });
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('zyzgsubitem/insert', data);
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('zyzgsubitem/update/' + id, data);
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('zyzgsubitem/delete/', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        DataGrid.selections = [];
                        DataGrid.refresh();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method getSelection
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getSelection = () => {
    return DataGrid.selections;
}

const getUserSelectData = () => {
    const id = DataGrid.selections[0]
    return DataGrid.data.find(d => d.subId === id)
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

export default {
    insert,
    update,
    querySearch,
    remove,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    batchUpdate,
    getSelection,
    getUserSelectData
}